import { getToday } from "helpers/types/dates"
import { createDateAdapter } from "./create-date-adapter"

export const withIntradayDates = createDateAdapter(() => {
  const today = getToday()
  return { startDate: today, endDate: today }
})
